<div *ngIf="globalErrorMessage" class="formApiErrorContainer">
  <mat-error class="formApiError">{{globalErrorMessage}}</mat-error>
</div>
